export enum REQUEST_GRID_LOCATIONS {
  REQUESTS_INDEX = 'requests_index_page',
  CONTROLS_SHOW = 'controls_show_page',
  EVIDENCE_SHOW = 'evidence_show_page',
  POLICIES_SHOW = 'policies_show_page',
  VENDORS_SHOW = 'vendors_show_page',
}

// ID | Name | Type | Audit | Assignee | Due Date | Status | Linked Ticket | Mentions | Menu
export const REQUESTS_GRID_TEMPLATE_COLUMNS =
  'auto auto auto auto auto auto auto auto auto auto'
